import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { SuperDashboardCard } from "../../SuperDashboard";
import { FullscreenOutlined } from '@ant-design/icons';
import { useBoolean } from 'ahooks';
import { Button, Modal } from 'antd';
import { Axis, Chart, Legend, LineAdvance } from 'bizcharts';
import _ from 'lodash';
import React from 'react';
export var ResourceUtilizationTrend = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var colors = ['#0076F7', '#FF9000'];
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    focusing = _useBoolean2[0],
    focusingActions = _useBoolean2[1];
  var primaryContent = /*#__PURE__*/React.createElement(Chart, {
    scale: true,
    animate: true,
    autoFit: true,
    data: properties.datum,
    padding: [6, 0, 24, 0]
  }, /*#__PURE__*/React.createElement(LineAdvance, {
    size: 1,
    shape: "smooth",
    area: {
      position: 'key*value',
      color: ['type', ['rgba(152, 215, 254, 0.2)', 'rgba(255, 225, 153, 0.2)']]
    },
    position: "key*value",
    color: ['type', colors],
    animate: {
      appear: {
        animation: 'position-update'
      }
    }
  }), /*#__PURE__*/React.createElement(Axis, {
    visible: false,
    name: "value"
  }), /*#__PURE__*/React.createElement(Axis, {
    visible: true,
    name: "key",
    label: {
      style: {
        textAlign: 'end'
      }
    }
  }), /*#__PURE__*/React.createElement(Legend, {
    visible: false
  }));
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    extra: /*#__PURE__*/React.createElement(Button, {
      type: "text",
      icon: /*#__PURE__*/React.createElement(FullscreenOutlined, null),
      onClick: focusingActions.setTrue
    }),
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, _.uniqBy(properties.datum.toReversed(), 'type').map(function (item, itemIndex) {
    return /*#__PURE__*/React.createElement("span", {
      key: item.key,
      style: {
        display: 'flex',
        alignItems: 'center',
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: colors.toReversed()[itemIndex % colors.length],
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        marginRight: '8px',
        flexShrink: '0'
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        color: '#707275',
        marginRight: '20px',
        flexShrink: '0'
      }
    }, item.type), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: '20px',
        color: '#181A1D',
        fontWeight: '500',
        lineHeight: '28px',
        height: '28px',
        whiteSpace: 'nowrap',
        flexShrink: '1'
      }
    }, item.value));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100px'
    }
  }, primaryContent), /*#__PURE__*/React.createElement(Modal, {
    open: focusing,
    footer: false,
    onCancel: focusingActions.setFalse,
    title: properties.title,
    width: "64vw",
    centered: true,
    styles: {
      body: {
        height: '50vh'
      },
      footer: {
        display: 'none'
      }
    }
  }, primaryContent), properties.children);
});
ResourceUtilizationTrend.isProCard = true;